import type { UseFormReturn } from 'react-hook-form'

import type { EditBookingFormValues } from '../utils/editBookingValidation'

import { useFindControllerFlow } from './useFindControllerFlow'
import type { UseFindControllerFlowResult } from './useFindControllerFlow'
import { useFindDriverFlow } from './useFindDriverFlow'
import type { UseFindDriverFlowResult } from './useFindDriverFlow'

type UseMasterIntegrationArgs = {
  form: UseFormReturn<EditBookingFormValues>
}

type UseMasterIntegrationResult = UseFindDriverFlowResult & UseFindControllerFlowResult

export const useMasterIntegration = ({
  form,
}: UseMasterIntegrationArgs): UseMasterIntegrationResult => {
  const driverFlow = useFindDriverFlow({ form })
  const controllerFlow = useFindControllerFlow({ form })

  return { ...driverFlow, ...controllerFlow }
}
